window._ = require('lodash');

window.bootstrapDatepickerConfig = {
    dateFormat: 'YYYY-MM-DD',
    weekStart: 1,
    ignoreReadonly: true,
    orientation: 'auto',
    forceParse: false,
    language: document.getElementsByTagName('html')[0].getAttribute('lang'),
    format: {
        toDisplay: function (date) {
            return moment(date).format('DD-MM-YYYY');
        },
        toValue: function (date) {
            const moment = require('moment');
            const parsed = moment.utc(date, 'DD-MM-YYYY', true);

            if (parsed.isValid()) {
                return parsed.toDate();
            }

            const fallback = moment.utc(date);
            if (fallback.isValid()) {
                return fallback.toDate();
            }

            return null;
        }
    }
}

require('@noardcode/compass-core');
require('@noardcode/compass-financial');
require('@noardcode/compass-crm');
require('@noardcode/compass-forms');
require('@noardcode/compass-side-panels');
require('@noardcode/compass-tables');
require('@glidejs/glide/dist/glide.min');
require('./../../vendor/noardcode/compass-tables/resources/js/plugins/selectable.js');

require('./tools/blur');

$(document).ready(() => {
    /** Plugins */
    require('./plugins/direct-upload-button');
    require('./plugins/handle-form');

    /** Modules */
    require('./organisations/metadata');
    require('./sales-orders/sales-orders');
    require('./production/production');
    require('./production/packaging');
    require('./plugins/table-row-click');
    require('./assembly-orders/assembly-order-batch-numbers');
    require('./assembly-orders/finalize-confirm');
    require('./goods-deliveries/create');
})
